<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    {{message}}
    @if (reject) {
    <mat-form-field appearance="outline" style="width: 100%; margin-top: 15px; ">
        <mat-label>Motivo</mat-label>
        <textarea matInput cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" [(ngModel)]="rejectComment"></textarea>
    </mat-form-field>
    }
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-button class="cancel-vacation" (click)="onCancel()" [disabled]="isDeleting">
        {{cancelText}}
    </button>
    <button mat-button [class]="isAcceptAction ? 'accept' : 'delete'" (click)="deleteSelected()"
        [disabled]="isDeleting">
        {{isDeleting ? (isAcceptAction ? 'Aceptando...' : 'Eliminando...') : confirmText}}
    </button>
</mat-dialog-actions>